import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toggleTimeoutModal, refreshRequest, logout, updateExpiration } from '@defi/core-auth';
import * as moment from 'moment';
import Auth from '@defi/core-auth';
import { ReactReduxContext } from 'react-redux';
const TIMEOUT_MODAL_DURATION = 300;
function TimeoutModalHOC(TimeoutModal, store) {
  class TimeoutModalContainer extends Component {
    constructor() {
      super();
      this.resetCountdown = expiration => {
        const expiredTime = expiration || Number(this.props.expiration);
        const bufferTime = expiredTime - 60;
        const currentTime = Math.floor(Date.now() / 1000);
        const sessionTime = bufferTime - currentTime;
        if (sessionTime) {
          if (sessionTime < 1) {
            this.handleStay();
          } else {
            this.startCountdown();
            this.setState({
              timeLeft: sessionTime
            });
          }
        } else {
          this.handleLogout();
        }
      };
      this.checkExpiration = () => {
        if (Number(localStorage.expiration) !== Number(this.props.expiration)) {
          clearInterval(this.interval);
          if (!localStorage.expiration) {
            this.handleLogout();
          }
          this.props.updateExpiration(Number(localStorage.expiration));
          //this.props.refreshRequest();
          return true;
        }
      };
      this.startCountdown = () => {
        this.interval = setInterval(() => this.countdown(), 1000);
      };
      this.countdown = () => {
        const timeLeft = this.state.timeLeft;
        if (!this.ismounted) return;
        const expirationChanged = this.checkExpiration();
        if (!expirationChanged) {
          this.setState({
            timeLeft: this.state.timeLeft - 1
          });
          if (timeLeft < TIMEOUT_MODAL_DURATION && timeLeft > 0) {
            if (!this.props.open) {
              this.props.toggleTimeoutModal(true);
            }
            const timeLeftFormatted = moment.duration(timeLeft * 1000);
            const seconds = timeLeftFormatted.seconds();
            const minutes = timeLeftFormatted.minutes();
            const secondsView = seconds > 9 ? seconds : '0' + seconds;
            const view = minutes + ':' + secondsView;
            this.setState({
              clock: view
            });
          } else if (timeLeft < 1) {
            this.handleLogout();
          }
        }
      };
      this.close = () => {
        clearInterval(this.interval);
        this.props.toggleTimeoutModal(false);
      };
      this.stay = () => {
        this.props.refreshRequest();
        this.close();
      };
      this.handleLogout = () => {
        Auth.logout();
        this.close();
      };
      this.ismounted = false;
      this.state = {
        timeLeft: 0,
        clock: '0:00'
      };
    }
    componentDidMount() {
      this.ismounted = true;
      clearInterval(this.interval);
      this.resetCountdown(null);
    }
    componentWillUnmount() {
      clearInterval(this.interval);
      this.ismounted = false;
    }
    UNSAFE_componentWillUpdate(nextProps, nextState) {
      if (Number(nextProps.expiration) && Number(this.props.expiration) !== Number(nextProps.expiration)) {
        clearInterval(this.interval);
        this.resetCountdown(Number(nextProps.expiration));
      }
    }
    render() {
      return (
        /*#__PURE__*/
        // <ReactReduxContext.Consumer>
        //   {({ store }) => {
        //     return (
        React.createElement(TimeoutModal, {
          open: this.props.open,
          handleLogout: this.handleLogout,
          clock: this.state.clock,
          stay: this.stay,
          store: store
        })
        //     )
        //   }}

        // </ReactReduxContext.Consumer>
      );
    }
  }
  const mapStateToProps = state => {
    const timeoutModal = state.timeoutModal;
    return {
      expiration: timeoutModal.expirationTime,
      open: timeoutModal.modalIsOpen
    };
  };
  const mapDispatchToProps = dispatch => bindActionCreators({
    toggleTimeoutModal,
    refreshRequest,
    updateExpiration,
    logout
  }, dispatch);
  return connect(mapStateToProps, mapDispatchToProps)(TimeoutModalContainer);
}
export default TimeoutModalHOC;